import CloseIcon from '@mui/icons-material/Close';
import { SvgIconOwnProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';

type CloseButtonProps = {
  // eslint-disable-next-line unused-imports/no-unused-vars
  onClick: (...args: any[]) => any;
  iconSx?: SvgIconOwnProps['sx'];
};

function CloseButton({ onClick, iconSx }: CloseButtonProps) {
  return (
    <IconButton onClick={onClick} aria-label="Close">
      <CloseIcon sx={iconSx} />
    </IconButton>
  );
}

export default CloseButton;
